import * as auth from "./auth";
import * as profile from "./profile";
import * as admin from "./admin";
import * as payment from "./payment";
import * as discount from "./discount";

export const api = {
    auth,
    profile,
    admin,
    payment,
    discount,
};
